module.exports = {
	"API_URL": "http://localhost:3667/api/",
	"SIGNALR_URL": "http://localhost:3666/signalr"
};


//////////////////
// WEBPACK FOOTER
// ./src/constants/appsettings.json
// module id = 555
// module chunks = 0